import { LabelValueSet } from "../utility/LabelValueSet";

const CareRecipientHouseIdType = Symbol();

// ハウスIDの最大長
export const CareRecipientHouseIdMaxLength = 100;

export class CareRecipientHouseId {
    [CareRecipientHouseIdType]: any;
    readonly value: string;

    private constructor(houseId: string) {
        this.value = houseId;
    }

    static fromString(houseId: string): CareRecipientHouseId {
        return new CareRecipientHouseId(houseId);
    }

    // 氏名の最大長チェック
    isValidLength(): boolean {
        return !(this.value.length > CareRecipientHouseIdMaxLength);
    }
}

export const HouseIdPrefixList: string[] = [
    "AMED",
    "IIF",
    "TKWS",
    "WAMED022"
];

export const houseIdPrefixLabelValueSets: LabelValueSet[] = [
    new LabelValueSet("AMED", "AMED"),
    new LabelValueSet("IIF", "IIF"),
    new LabelValueSet("TKWS", "TKWS"),
    new LabelValueSet("WAMED022", "WAMED022")
];